import React, { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiLoader, MiPlaceholderIcon } from "@miplatform/components";
import { CONTACT_TYPES } from "@miplatform/constants";
import { LoaderType } from "@miplatform/types";
import { mdiAccount } from "@mdi/js";
import { MiContactCard } from "@mibuildweb/components";
import { useHome } from "@mibuildweb/hooks";
import { Box } from "@mui/material";

export const WorkOrderDrawerContactsTab = ({
  homeId,
}: WorkOrderDrawerContactsTabProps): React.ReactNode => {
  const { classes } = useStyles();
  const { home, getHome, isLoading } = useHome();
  const contacts = home?.contacts ?? [];

  useEffect(() => {
    if (homeId) {
      getHome(homeId);
    }
  }, [homeId]);

  return (
    <Box className={classes.container}>
      <MiLoader isLoading={isLoading} type={LoaderType.Linear} />
      {home && !contacts.length && (
        <Box alignSelf="center" mt={4}>
          <MiPlaceholderIcon
            icon={mdiAccount}
            text="No Contacts Found"
            helperText="There are no contacts associated with this home."
          />
        </Box>
      )}
      {contacts.map((contact, index) => (
        <MiContactCard
          key={`${contact.id}${contact.level}${index}`}
          isPrimaryDisabled
          contact={contact}
          defaultContactLevel={CONTACT_TYPES.HOMES}
        />
      ))}
    </Box>
  );
};

interface WorkOrderDrawerContactsTabProps {
  homeId?: string;
}

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
